module.exports = __webpack_public_path__ + "static/media/use_graph01_ch01.6ebeba60.jpg";